import React, {useState, useTransition} from 'react';

import {useAppKitProvider} from "@reown/appkit/react";
import {useTranslation} from "react-i18next";
import {format} from "date-fns";
import {ethers} from "ethers";

import {
    SIZE,
    ERROR,
    WARNING,
    SUCCESS,
    INFORMATION,
    INTERACTION,
    errorHandler,
    STEPS_STATUS,
    BUTTON_VARIANT,
    walletAndTransactionErrorHandle
} from "utils";
import {useCancelListedOrderMutation} from "store/Bazaar/bazaar.api";
import {useActionContext} from "../useActionContext";
import {useModalsContext} from "layouts";

import {ButtonV2, Information, Modal} from "components/atoms";
import {Process, InfoItem} from "./components"

import "../../style.scss"

const BazaarCurrentItemCancelListingModal = () => {
    const [isPending, startTransition] = useTransition()
    const {setCurrentModal, currentModal} = useModalsContext()
    const {setActionDetails} = useActionContext()
    const {walletProvider} = useAppKitProvider("eip155");
    const {t} = useTranslation()

    const [informationStatus, setInformationStatus] = useState({
        type: INFORMATION.WARNING,
        text: WARNING.LISTING_CANCEL
    })

    const {created_at, expiration_date, id, inventory} = currentModal.data

    const [cancelListing] = useCancelListedOrderMutation()

    const handleCancelListing = () => {
        startTransition(async () => {
            try {
                const provider = new ethers.providers.Web3Provider(walletProvider)
                const signer = provider.getSigner()
                const address = await signer.getAddress()

                const message = "Please sign to confirm the removal of your KOMPETE inventory listing"
                const signature = await signer.signMessage(message)
                const signerAddress = ethers.utils.verifyMessage(message, signature);

                if (signerAddress.toLowerCase() !== address.toLowerCase()) {
                    errorHandler(ERROR.INVALID_SIGNATURE)
                }

                const response = await cancelListing({
                    order_id: id
                }).unwrap()

                if (response.success) {
                    setInformationStatus({
                        type: INFORMATION.SUCCESS,
                        text: SUCCESS.LISTING_CANCEL
                    })

                    setActionDetails({
                        type: INTERACTION.CANCEL,
                        isSuccess: true,
                        data: {
                            order_id: id,
                        },
                    })

                    setTimeout(() => {
                        setCurrentModal({status: STEPS_STATUS.CLOSE})
                    }, 3000)
                } else {
                    errorHandler(ERROR.WRONG)
                }
            } catch (error) {
                const text = walletAndTransactionErrorHandle(error, false)

                setInformationStatus({
                    type: INFORMATION.ERROR,
                    text
                })
            }
        })
    }

    return (
        <Modal
            isOpen={true}
            size={SIZE.SMALL}
            title={t("cancelListingModalTitle")}
            onClose={() => setCurrentModal({status: STEPS_STATUS.CLOSE})}
        >
            <div className="bazaar-current-item_cancel-listing-modal">
                <span className="bazaar_current-item_cancel-listing-modal_under-title">{t("cancelListingModalSubTitle")}</span>
                <div className="bazaar_current-item_cancel-listing-modal_item-info">
                    <InfoItem name="item" value={inventory.name}/>
                    <InfoItem name="tokenId" value={inventory.token_id}/>
                    <InfoItem name="listedOn" value={format(new Date(created_at), 'yyyy-MM-dd')}/>
                    <InfoItem name="expired" value={format(new Date(expiration_date), 'yyyy-MM-dd')}/>
                </div>
            </div>
            {isPending ? <Process/> : <Information
                type={informationStatus.type}
                text={informationStatus.text}
            />}
            <div className="bazaar_current-item_cancel-listing-modal_btns">
                <ButtonV2
                    size={SIZE.MEDIUM}
                    onClick={() => setCurrentModal({status: STEPS_STATUS.CLOSE})}
                    disabled={isPending || informationStatus.type === INFORMATION.SUCCESS}
                >
                    cancel
                </ButtonV2>
                <ButtonV2
                    size={SIZE.MEDIUM}
                    variant={BUTTON_VARIANT.RED}
                    onClick={handleCancelListing}
                    disabled={isPending || informationStatus.type === INFORMATION.SUCCESS}
                >
                    confirm
                </ButtonV2>
            </div>
        </Modal>
    )
}

export default BazaarCurrentItemCancelListingModal